// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3zdWg","alertIcon":"ConfirmModal_alertIcon__kPGcX"};